export default __webpack_public_path__ + "static/media/opensans-lightitalic-webfont.bfeccb67.woff";